// Hardware specifications shared between components
export const HARDWARE_OPTIONS = [
  { value: 'h100', label: 'NVIDIA H100', specs: '80GB HBM3 • 989 GB/s • 2000W' },
  { value: 'a100', label: 'NVIDIA A100', specs: '40GB HBM2e • 1555 GB/s • 400W' },
  { value: 'rtx4090', label: 'RTX 4090', specs: '24GB GDDR6X • 1008 GB/s • 450W' },
  { value: 'cpu-intel', label: 'Intel Xeon', specs: 'x86-64 • AVX-512 • Up to 56 cores' },
  { value: 'cpu-amd', label: 'AMD EPYC', specs: 'x86-64 • AVX2 • Up to 64 cores' },
  { value: 'mobile', label: 'Mobile/Edge', specs: 'ARM Cortex • Mali/Adreno • Low power' }
];

export const SUPPORTED_FILE_TYPES = ['.pth', '.pt', '.pkl', '.py'];

export const FILE_TYPE_DESCRIPTIONS = {
  '.pth': 'PyTorch model state dictionary',
  '.pt': 'TorchScript model',
  '.pkl': 'Python pickle format',
  '.py': 'Golden function implementation for layer optimizations'
};